<template>
  <Row>
    <Col cols="12">
      <Link
        blank
        class="ml-3"
        color="primary"
        href="https://ajuda.locaweb.com.br/wiki/configurando-o-dominio-criador-de-sites/"
        v-text="lc.knowHow"
      />
    </Col>
  </Row>
</template>

<script>
import { Link, Row, Col } from '@locaweb/design-system-vue'

export default {
  name: 'KnowHow',
  components: {
    Row,
    Col,
    Link
  },
  computed: {
    lc () {
      return this.$lc('domains.addDomain.domainStatus.domain_not_configured.modal')
    }
  }
}
</script>
